/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCurrencyLari = createReactComponent("currency-lari", "IconCurrencyLari", [
  ["path", { d: "M18 13a6 6 0 1 0 -6 6", key: "svg-0" }],
  ["path", { d: "M6 19h12", key: "svg-1" }],
  ["path", { d: "M10 5v7", key: "svg-2" }],
  ["path", { d: "M14 12v-7", key: "svg-3" }]
]);

export { IconCurrencyLari as default };
//# sourceMappingURL=IconCurrencyLari.js.map
